import { IconButton } from "@chakra-ui/react";
import { Delete } from "@airhelp/icons";
import { useMobileMenuStore } from "stores/MobileMenuStore";
import { HamburgerMenuIcon } from "styles/icons";
import type { HeaderNavProps } from "./HeaderNav.d";
import { MobileMenuContent } from "./MenuItems/MobileMenuContent";

export const MobileMenuTrigger = ({
  headerButtons,
  menuItems,
}: Pick<HeaderNavProps, "headerButtons" | "menuItems">) => {
  const { openMobileMenu, isOpen: isMobileMenuOpen, close: closeMobileMenu } = useMobileMenuStore();
  const handleMobileMenuButtonClick = () =>
    isMobileMenuOpen
      ? closeMobileMenu()
      : openMobileMenu(<MobileMenuContent headerButtons={headerButtons} menuItems={menuItems} />);

  return (
    <IconButton
      h={8}
      minH="initial"
      icon={isMobileMenuOpen ? <Delete color="primary.900" h={4} /> : <HamburgerMenuIcon color="primary.900" h={4} />}
      p={0}
      variant="unstyled"
      minWidth={6}
      _hover={{}}
      _active={{}}
      display={{ base: "flex", lg: "none" }}
      onClick={handleMobileMenuButtonClick}
      data-testid="mobile-menu-button"
      aria-label="Open menu"
      justifyContent="flex-end"
    />
  );
};
